import { render, staticRenderFns } from "./SalesList_Export.vue?vue&type=template&id=35fd7614&"
import script from "./SalesList_Export.vue?vue&type=script&lang=js&"
export * from "./SalesList_Export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports